var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.coupon ? _c('coupon', _vm._g(_vm._b({
    attrs: {
      "coupon": _vm.coupon,
      "redeem-from-outside": true
    },
    on: {
      "redeemFromOutside": _vm.redeem
    }
  }, 'coupon', _vm.$attrs, false), _vm.$listeners)) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }